import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { skipOnboardingStep, updateAccountType, updateAccountWebsite } from 'services/api/onboarding';
import { fetchSocialAccountsThunk, fetchUser } from 'slices/auth/thunk';
import { AppDispatch, RootState } from 'store';
import { getErrorMessage } from 'utils/helpers';
import instagramPlatformLogo from "assets/images/platforms/platform-instagram.png"
import { useNavigate } from 'react-router-dom';
import { addSocialAccount } from 'services/api/social-account';
import AISuggestions from '../AISuggestions';


const platforms = [
    {
        id: 'ig',
        name: 'Instagram',
    },
]


const platformLogos = {
    ig: instagramPlatformLogo,
};


const AddSocialAccountStep = () => {

    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [skipping, setSkipping] = useState(false);
    const dispatch: AppDispatch = useDispatch();
    const [processing, setProcessing] = useState(false);

    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = useState<{ platform?: string, handle?: string }>({});
    const socialAccounts = useSelector((state: RootState) => state.auth.social_accounts.items);
    const maxIGAccountsLimit = useSelector((state: RootState) => state.auth.configurations?.agency_max_ig_accounts);
    const [maxSocialAccountsConfig, setMaxSocialAccountsConfig] = useState<Record<string, number>>({
        ig: Number(maxIGAccountsLimit),
    })
    const navigate = useNavigate();


    useEffect(() => {
        setMaxSocialAccountsConfig({
            ig: Number(maxIGAccountsLimit),
        })
    }, [maxIGAccountsLimit])


    const availablePlatforms = platforms.filter(platform => {
        const maxForPlatform = maxSocialAccountsConfig[platform.id] || 1;
        const currentCountForPlatform = socialAccounts.filter((account) => account.social_account.platform === platform.id).length;

        return currentCountForPlatform < maxForPlatform;
    });

    const [data, setData] = useState<{ platform: string, handle: string }>({ platform: 'ig', handle: '' });

    const validateForm = () => {
        let newErrors: { platform?: string, handle?: string } = {};
        if (!data.platform) {
            newErrors.platform = "Please select a social media platform.";
        }
        if (!data.handle) {
            newErrors.handle = "Please enter your social media handle or profile link.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateForm() || !selectedAgencyId) return;
        try {
            setProcessing(true);
            const res = await addSocialAccount(selectedAgencyId, data)
            toast.success("Social account added successfully.");
            dispatch(fetchSocialAccountsThunk({ force: true }));
            dispatch(fetchUser());
        } catch (error: any) {
            console.error(error);
            toast.error(getErrorMessage(error) || "Failed to add social account. Please try again.");
        } finally {
            setProcessing(false);
        }
    }


    const onSkip = async () => {
        try {
            if (!selectedAgencyId) return;
            setSkipping(true);
            await skipOnboardingStep(selectedAgencyId, 'social_account');
            dispatch(fetchUser());
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error));
        } finally {
            setSkipping(false);
        }
    }
    return (
        <div className='onboarding-step'>
            <div className="d-flex align-items-center flex-column gap-3">
                <h3>Add your Instagram account</h3>
                <span>So you can collaborate with creators and track campaign performance.</span>
            </div>
            <div className='d-flex flex-column gap-4'>
                <div className="onboarding-step-field flex-column align-items-start">
                    <input type="text" className="onboarding-step__input__field ps-3" value={data.handle}
                        onBlur={validateForm}
                        onChange={(e) => {
                            setData({ ...data, handle: e.target.value });
                        }} placeholder='@instagram_handle' />
                    {errors.handle && <div className="text-danger font-12 mt-1">{errors.handle}</div>}
                </div>
                <AISuggestions step='ig' onClick={(value) => setData({ ...data, handle: value })} activeSuggestion={data.handle} />
            </div>
            <div className="onboarding-step-footer d-flex align-items-center gap-3 w-100 justify-content-center position-absolute  flex-column flex-md-row">
                <button className='btn skip-btn' disabled={skipping} onClick={onSkip}>{skipping ? 'Please wait...' : 'Skip'}</button>
                <button className='btn btn-gradient' disabled={!data.handle || processing} onClick={handleSubmit}>{processing ? 'Please wait...' : 'Continue'}</button>
            </div>
        </div>
    )
}

export default AddSocialAccountStep